(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_buy-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
    const containers = document.querySelectorAll('.buy-buttons-block [data-accelerated-checkout-text]');
    if (!containers.length) return;

    for (const container of containers) {
      const customText = container.getAttribute('data-accelerated-checkout-text');
      if (!customText) continue;

      const applyText = () => {
        const button = container.querySelector('.shopify-payment-button__button');
        if (!button) return;

        button.textContent = customText;
      };

      applyText();

      const observer = new MutationObserver(() => {
        applyText();
      });

      observer.observe(container, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_jv-modelo-veste"] && !Shopify.designMode) return;
  try {
    class JvModeloVeste extends HTMLElement {
    connectedCallback() {
      if (this._timer) window.clearInterval(this._timer);

      const slides = Array.from(this.querySelectorAll('[data-jv-modelo-slide]'));
      if (slides.length < 2) return;

      this.classList.add('jv-modelo-veste--rotate');

      slides.forEach((slide, i) => {
        const active = i === 0;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const interval = Number(this.dataset.interval) || 5000;
      let index = 0;

      this._timer = window.setInterval(() => {
        const current = slides[index];
        const nextIndex = (index + 1) % slides.length;
        const next = slides[nextIndex];

        current.classList.remove('is-active');
        current.setAttribute('aria-hidden', 'true');
        next.classList.add('is-active');
        next.setAttribute('aria-hidden', 'false');
        index = nextIndex;
      }, interval);
    }

    disconnectedCallback() {
      if (this._timer) {
        window.clearInterval(this._timer);
        this._timer = null;
      }
    }
  }

  if (!customElements.get('jv-modelo-veste')) {
    customElements.define('jv-modelo-veste', JvModeloVeste);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_jv-product-description-excerpt"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.jvProductDescExcerptInited) return;
    window.jvProductDescExcerptInited = true;

    document.addEventListener('click', function (event) {
      const link = event.target.closest('[data-jv-desc-excerpt-link]');
      if (!link) return;

      event.preventDefault();

      const tabs = document.querySelector('.jv-product-tabs');
      if (tabs) {
        tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      const descriptionSection = document.querySelector('[data-product-description], .product-description, #product-description');
      if (descriptionSection) {
        descriptionSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
